/**
 * @description Component-OpenOrders
 */
import './index.less';

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useWrappedOrderListByUser } from '@/features/account/orderHook';
import { useIsFetchedPortfolioList } from '@/features/portfolio/hook';
import { useChainId, useUserAddr } from '@/hooks/web3/useChain';
import TradeOpenOrders from '@/pages/trade/TradePortfolio/TradeOpenOrders';
interface IPropTypes {
  className?: string;
}
const OpenOrders: FC<IPropTypes> = function ({}) {
  const { t } = useTranslation();
  const chainId = useChainId();
  const userAddr = useUserAddr();
  const orders = useWrappedOrderListByUser(chainId, userAddr, false);
  const isFetchedPortfolio = useIsFetchedPortfolioList(chainId, userAddr);

  if (isFetchedPortfolio && !orders?.length) {
    return null;
  }
  return (
    <>
      <div className="syn-open-orders">
        <div className="title">{t('common.openOrders')}</div>
        <TradeOpenOrders isTradePage={false} />
      </div>
    </>
  );
};

export default OpenOrders;
